/**
 * 참여자 페이지 공통 푸터
 *
 * 신청 페이지와 제출 페이지에서 동일한 푸터를 공유한다.
 * 회사(인사이트웨이브) 정보, 개인정보처리방침, 이용약관 링크를 포함한다.
 *
 * 운영자(고객사) 문의처는 발견성을 위해 본문 안의 <ContactCard>로 노출한다.
 * (과거에는 이 푸터에 있었으나 최하단이라 잘 보이지 않아 분리했다.)
 */
export function Footer() {
  return (
    <footer className="border-t border-border bg-surface py-8 text-xs text-outline-variant mt-auto">
      <div className="px-6 space-y-1">
        {/* 회사(인사이트웨이브) 정보 */}
        <p>주식회사 인사이트웨이브 &nbsp;|&nbsp; 대표자명 최수임</p>
        <p>사업자등록번호 730-88-03708</p>
        <p>대전광역시 유성구 대학로179번길 15-14, H1동 202호</p>
        <p>이메일 1bpluschool@inwv.co</p>
        <p className="pt-2">
          {/* 자체 페이지(REQ-199). 상대 경로라 app·review 어느 도메인에서 열어도 그 도메인에 머문다.
              새 탭으로 여는 건 작성 중인 신청 폼을 잃지 않기 위해서다. */}
          <a href="/apply/privacy" target="_blank" rel="noopener noreferrer" className="hover:text-on-surface underline">개인정보처리방침</a>
          &nbsp;|&nbsp;
          <a href="/apply/terms" target="_blank" rel="noopener noreferrer" className="hover:text-on-surface underline">이용약관</a>
        </p>
        <p className="pt-3 text-outline-variant">Powered by 자사몰 사관학교 솔루션</p>
      </div>
    </footer>
  )
}
